var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.427 13.0312C22.427 14.6292 21.1321 15.9241 19.5355 15.9241C17.9375 15.9241 16.6426 14.6292 16.6426 13.0312C16.6426 11.4346 17.9375 10.1396 19.5355 10.1396C21.1321 10.1396 22.427 11.4346 22.427 13.0312Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9306 3.27432V2.47194C17.9306 1.58297 17.2094 0.867188 16.3259 0.867188H2.54994C1.66096 0.867188 0.94518 1.58837 0.94518 2.47194V7.50672C0.673209 7.74893 0.5 8.09531 0.5 8.48229C0.5 9.21567 1.10078 9.80966 1.82737 9.80966H2.13316C2.31177 9.80966 2.48496 9.76907 2.64734 9.70547H2.65952V9.72306C3.33471 9.21567 4.16008 8.89769 5.07206 8.89769C7.2884 8.89769 9.09088 10.6986 9.09088 12.9165H15.522C15.522 11.2711 16.5151 9.86259 17.9345 9.23888L17.9358 3.27439L17.9306 3.27432Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95976 13.0312C7.95976 14.6292 6.66485 15.9241 5.0682 15.9241C3.4702 15.9241 2.17529 14.6292 2.17529 13.0312C2.17529 11.4346 3.4702 10.1396 5.0682 10.1396C6.66485 10.1396 7.95976 11.4346 7.95976 13.0312Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1641 8.83446V5.68855L24.2751 3.9106C23.8774 3.11362 22.8382 2.47363 21.9492 2.47363H18.7329V8.98472C18.9927 8.93331 19.2647 8.90354 19.5353 8.90354C21.7516 8.90354 23.5541 10.7045 23.5541 12.9224C24.4431 12.9224 25.1589 12.2012 25.1589 11.3176V11.3C25.3496 11.2824 25.4998 11.1322 25.4998 10.936L25.4985 9.19867C25.5053 9.00247 25.3481 8.85747 25.1641 8.83446ZM20.3375 6.49093V3.27462H21.9423C22.3875 3.27462 22.907 3.59801 23.1032 3.99581L24.0098 5.81436V6.49089L20.3375 6.49093Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.7ba4dd1aa4c8052c448efe254602f46e.svg";
export { ForwardRef as ReactComponent };